import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlogSliderComponent } from './blog-slider.component';
import { RouterModule } from '@angular/router';

// const routes: Routes = [
//   { path: '', component: BlogSliderComponent },
// ];

@NgModule({
  declarations: [BlogSliderComponent],
  imports: [
    CommonModule,
    RouterModule
  ],
  exports: [BlogSliderComponent]
})
export class BlogSliderModule { }